<template>
  <div>
    <!-- Width 1000, Height 750 -->
    <svg class="app__viz" version="1.1" viewBox="-40 -80 1080 880" ref='viz'>
      <!-- X scale 0 - 1000 , Y scale 0 - 720 , margin of 40 -->

      <g class='map-legend legend' transform="translate(500, 648)"></g>
      <g class='scatter-legend legend' transform="translate(450, 648)"></g>
      <g class="axis ranking-arrow" transform="scale(3.8, 3.4) translate(83, 185)">
        <path d="M 66.01,11 2,11 l 0,2 64.01,0 0,3 L 70,12 66.01,8 z"/>
      </g>
      
      <!-- viewBox : relative to the data in the map -->
      <!-- x, y, width & height : relative to sizing data -->
      <!-- Leaving 80 off the height to be used for legend -->
      <!-- <rect x=0 y=0 width=900 height=648 fill=none stroke="blue"></rect> -->
      <svg id="greater-sydney" viewBox="100 80 763.88 550" x=0 y=0 width=900 height=648>
        <greater-sydney></greater-sydney>
      </svg>
    </svg>

    <!-- Should move this into its own file -->
    <the-tooltip></the-tooltip>

  </div>
</template>

<script>
  /* eslint-disable */
  import { mapState, mapMutations, mapGetters } from 'vuex'
  import { select, selectAll, event, selectorAll } from 'd3-selection'
  import { scaleOrdinal, scaleSequential, scalePoint, scaleLinear } from 'd3-scale'
  import { 
    schemeCategory10, interpolateBlues, schemeBlues, schemeAccent, 
    schemes, interpolateViridis, interpolateOranges, interpolateOrRd, interpolateGreys 
  } from 'd3-scale-chromatic'
  import { axisBottom , axisRight } from 'd3-axis'
  import { transition } from 'd3-transition'
  import { format } from 'd3-format'
  import { symbol, symbolTriangle } from 'd3-shape'
  import { legendColor} from 'd3-svg-legend'

  import GreaterSydney from './GreaterSydney'
  import TheTooltip from './TheTooltip'

  export default {
    components: {
      GreaterSydney,
      TheTooltip
    },
    computed: {
      ...mapState([
        'currentView',
        'scrollDirection',
        'data',
        'avg_drive_time_domain',
        'avg_pt_time_domain',
        'avg_rent_domain',
        'avg_rent_real_domain',
        'postcode_rankings'
      ]),
      ...mapGetters([
        'highlightedPostcode'
      ]),
      modeColourScale() {
        return scaleOrdinal(['#fff', '#B300FF', '#ff00c3', '#00ccff', '#fffb00' ])
          .domain(this.data.map(d => d.primary_mode_driving))
      },
      regionColourScale() {
        return scaleOrdinal(['#B300FF', '#ff00c3', '#00ccff', '#fffb00', '#ff8c00', '#00FF63' ])
          .domain(this.data.map(d => d.region))
      },
      driveColourScale() {
        return scaleSequential(interpolateBlues)
          .domain(this.avg_drive_time_domain)
      },
      ptColourScale() {
        return scaleSequential(interpolateBlues)
          .domain(this.avg_pt_time_domain)
      },
      rentColourScale() {
        return scaleSequential(interpolateBlues)
          .domain(this.avg_rent_domain)
      },
      rentRealColourScale() {
        return scaleSequential(interpolateOrRd)
          .domain(this.avg_rent_real_domain)
      },
      postcodeScale() {
        return scalePoint()
          .domain(this.postcode_rankings)
          .range([100, 863])
      },
      ptYScale() {
        return scaleLinear()
          .domain(this.avg_pt_time_domain)
          .range([630, 80])
      },
      rentYScale() {
        return scaleLinear()
          .domain([this.avg_rent_domain[0],1000])//hardcode max rent to 1000
          .range([630, 80])
      },
      ptXScale() {
        return scaleLinear()
          .domain(this.avg_pt_time_domain)
          .range([100, 863])
      },
      rentAxis() {
        return axisRight(this.rentYScale)
      },
      ptYAxis () {
        return axisRight(this.ptYScale)
      },
      postcodeAxis () {
        return axisBottom(this.postcodeScale)
      },
      ptXAxis() {
        return axisBottom(this.ptXScale)
      }
    },
    watch: {
      currentView(newView, oldView) {
        if (newView === 'intro') {
          this.draw_intro()
        } else if (newView === 'first') {
          // 1. Isochrmoatic
          this.draw_avg_pt_time()
        } else if (newView === 'second') {
          // 2. Mode w/ driving
          this.draw_primary_mode_driving()
        } else if (newView === 'third') {
          // 3. Mode w/ pt
          this.draw_primary_mode_pt()
        } else if (newView === 'fourth') {
          // 4. Scatter pt time
          this.draw_pt_scatter()
        } else if (newView === 'fifth') {
          // 5. Scatter rent time
          this.draw_rent_scatter()
        } else if (newView === 'landing') {
          this.draw_landing()
        } else if (newView === 'findings') {
          this.draw_findings()
        } else if (newView === 'sixth') {
          this.draw_rent_pt_scatter()
        } else if (newView === 'seventh') {
          this.draw_rent_map()
        }
      },
      highlightedPostcode (highlight) {
        if (!highlight) {
          selectAll('.postcode')
            .style("opacity", 1)
        } else {
          selectAll('.postcode')
            .style("opacity", d => {
              if (d.postcode === highlight.postcode) {
                return 1
              } else {
                return 0.2
              }
            })
        }
      }
    },
    mounted() {

      const vm = this 

      // Bind data to map
      let postcodes = selectAll('.postcode')
        .data(vm.data, function (d) {
          return d ?
            d.postcode :
            this.firstElementChild.getAttribute("data-poa-code16");
        })

      // Remove excess postcodes
      postcodes.exit()
        .remove()

      // For each data point set the corresponding 
      // postcode path's transform-origin
      postcodes.select('.postcode__path')
        .style("opacity", 0)
        .style("fill", "rgb(144,159,239)")
        .style("transform-origin", function (d, i) {
          let bbox = this.getBBox()
          let x = bbox.x + bbox.width / 2
          let y = bbox.y + bbox.height / 2
          return `${x}px ${y}px 0`
        })
        .attr("transform-origin", function (d, i) {
          let bbox = this.getBBox()
          let x = bbox.x + bbox.width / 2
          let y = bbox.y + bbox.height / 2
          return `${x} ${y} 0`
        })

      // For each data point add a circle
      // at the corresponding postcode path's center
      postcodes.append('circle')
        .attr("class", "postcode__circle")
        .attr("cy", function (d, i) {
          d.BBox = this.parentNode.getBBox()
          d.BBoxCenter = {
            x: d.BBox.x + d.BBox.width / 2,
            y: d.BBox.y + d.BBox.height / 2
          }
          return d.BBoxCenter.y
        })
        .attr("cx", function (d, i) {
          return d.BBoxCenter.x
        })
        .style("transform-origin", function (d, i) {
          let bbox = this.getBBox()
          let x = bbox.x + bbox.width / 2
          let y = bbox.y + bbox.height / 2
          return `${x}px ${y}px 0`
        })
        .attr("transform-origin", function (d, i) {
          let bbox = this.getBBox()
          let x = bbox.x + bbox.width / 2
          let y = bbox.y + bbox.height / 2
          return `${x} ${y} 0`
        })
        .style("fill", "rgb(108, 173, 213)")
        .attr("r", 7)
        .attr("transform", "scale(0.000001)")
        .style("opacity", 0)

      // Hide Legends and Axes
      selectAll('.legend, .axis')
        .style("opacity", 0)


      postcodes.on('mouseenter', function (d, i, nodes) {
        event.stopPropagation()
        if(!("ontouchstart" in document.documentElement)){
          // if(!vm.postcodeSelected){
          vm.update_hover_postcode(d)
          // }
        }
      })
      
      postcodes.on('mouseleave', function (d) {
        event.stopPropagation()
        vm.update_hover_postcode(null)
      })

      postcodes.on('mousedown', function (d) {
        event.stopPropagation()
        vm.update_selected_postcode(d)        
      })

      // Catchall for hiding tooltips
      // Note: requires stopPropogation on other events!
      select('#app').on('mousedown', () => vm.update_selected_postcode(null))

    },
    methods: {
      ...mapMutations([ 'update_hover_postcode', 'update_selected_postcode' ]),
      draw_landing () {
        const vm = this
        let postcodes = selectAll('.postcode')
        // Interrupt any axisiting transitions
        selectAll('*').interrupt()

        // Transition everything to 0 opacity
        postcodes.select('.postcode__path')
            .transition()
            .style("opacity", 0)
        
        selectAll('.axis, .legend')
          .style("opacity", 0)
      },
      /*
       *  INTRO VIEW
       *  Discovering Our City Through Data  
       */
      draw_intro() {
        const vm = this
        let postcodes = selectAll('.postcode')
        let paths = postcodes.select('.postcode__path')
        let circles = postcodes.select('.postcode__circle')
        
        // Interrupt any existing transitions
        selectAll('*').interrupt()
        
        // Transition all the postcodes to the 1 colour
        paths
          .transition()
          .duration(500)
          .delay((d, i) => i * 10)
            .style("opacity", 1)
            .style("fill", "rgb(144,159,239)")
            // .style("fill", d => vm.regionColourScale(d.region))
        
        selectAll('.axis, .legend')
          .style("opacity", 0)
      },
      /*
       *  FIRST VIEW
       *  Is Time On Your Side?
       */
      draw_avg_pt_time() {
        
        const vm = this
        let postcodes = selectAll('.postcode')
        let paths = postcodes.select('.postcode__path')
        let circles = postcodes.select('.postcode__circle')
                
        // Interrupt any existing transitions
        selectAll('*').interrupt()
        
        if (vm.scrollDirection === 'DOWN') {
          // circles
          //   .style('transform', 'scale(0.000001)')
          
          // Set to where it should be
          paths.transition()
            .duration(500)
              .style("opacity", 0.5)
              .style("fill", "rgb(144,159,239)")
          // Transition on the rest
          .transition()
            .duration(500)
            .delay((d, i) => i * 10)
              .style("opacity", 1)
              .style("fill", d => vm.ptColourScale(d.avg_pt_time))

        } else {
          // Set circles and axis where they should be
          circles
            .style("opacity", 0)
            .attr("transform", "scale(0.000001)")
            .attr("cx", d => d.BBoxCenter.x)
            .attr("cy", d => d.BBoxCenter.y)
          // Remove axis
          selectAll('.axis')
            .style("opacity", 0)

          paths
          // Set where they should be
            .style('fill', d => vm.modeColourScale(d.primary_mode_driving))
          // Transition
          .transition()
            .duration(500)
              .style('opacity', 0.25)
          .transition()
            .duration(500)
            .delay((d, i) => i * 10)
              .style('opacity', 1)
              .style("fill", d => vm.ptColourScale(d.avg_pt_time))
        }
        var legendOrdinal = legendColor()
            .shapeWidth(55)
            .cells([0,25,50,75,100])
            .title("AM peak public transport travel time to CBD (minutes)")
            .labelFormat(format(".0f"))
            .orient('horizontal')
            .scale(vm.ptColourScale);

        selectAll('.legend, .axis')
          .style("opacity", 0)
          
        // selectAll('.scatter-annotation').transition().style("opacity", 0)
        let legend = select(".map-legend")
          
        // Create the legend
        legend
          .call(legendOrdinal)
        select('.map-legend .cell:last-child .label')
          .text('100+')

        legend.select('.legendTitle')
          .attr("text-anchor", "middle")

        legend.select('.legendCells')
          .attr("transform", `translate(-${(5*55+4*2)/2},20)`)

        legend.transition()
          .delay(2000)
          .duration(500)
          .style("opacity", 1)

      },
      /*
       *  SECOND VIEW
       *  Tap-on or Fuel Up?
       */
      draw_primary_mode_driving() {
        const vm = this
        let postcodes = selectAll('.postcode')
        let paths = postcodes.select('.postcode__path')
        let circles = postcodes.select('.postcode__circle')
        
        // Interrupt any existing transitions
        selectAll('*').interrupt()

        circles
          .style("opacity", 0)
          .attr('transform', 'scale(0.000001)')
        paths
          .attr('transform', 'scale(1)')

        if (vm.scrollDirection === 'DOWN') {
          // Set to where it should be
          paths.transition()
            .duration(250)
              .style('opacity', 0.25)
              .style("fill", d => vm.ptColourScale(d.avg_pt_time))
          // Transition
          .transition()
            .duration(500)
            .delay((d, i) => i * 10)
              .style('opacity', 1)
              .style('fill', d => vm.modeColourScale(d.primary_mode_driving))

        } else {
          // Set circles and axis where they should be
          circles
            .attr("cx", d => d.BBoxCenter.x)
            .attr("cy", d => d.BBoxCenter.y)
          
          // Remove axis
          selectAll('.axis')
            .style("opacity", 0)
          
          // Set paths where they should be
          paths.style('fill', d => vm.modeColourScale(d.primary_mode))
            .transition()
              .style("opacity", 1)
          .filter(d => d.primary_mode !== d.primary_mode_driving)
          .transition()
            .duration(500)
              .style('opacity', 0.25)
          .transition()
            .duration(500)
            .delay((d, i) => i * 10)
              .style('opacity', 1)
              .style('fill', d => vm.modeColourScale(d.primary_mode_driving))

        }
        
        // Hide all legends / axis
        selectAll('.legend, .axis')
          .style("opacity", 0)

        let legendOrdinal = legendColor()
          .shapeWidth(55)
          .orient('horizontal')
          .title('Primary travel mode to CBD')
          .cellFilter(function(d){ return d.label !== "unknown" })
          .scale(vm.modeColourScale);
        let legend = select(".map-legend")
        legend.call(legendOrdinal)
        legend.select('.legendTitle')
          .attr("text-anchor", "middle")
        legend.select('.legendCells')
          .attr("transform", `translate(${-(4*55+3*2)/2},20)`)

        legend.transition()
          .delay(2000)
          .duration(500)
          .style("opacity", 1)
      },
      /*
       *  THIRD VIEW
       *  Our Public Transport Perspective
       */
      draw_primary_mode_pt() {

        const vm = this
        let postcodes = selectAll('.postcode')
        let paths = postcodes.select('.postcode__path')
        let circles = postcodes.select('.postcode__circle')
        
        // Interrupt any existing transitions
        selectAll('*').interrupt()

        if (vm.scrollDirection === 'DOWN') {
          circles
            .style("opacity", 0)
            .attr('transform', 'scale(0.000001)')
          // Set to where it should be
          paths.transition()
            .style('opacity', 1)
            .style('fill', d => vm.modeColourScale(d.primary_mode_driving))
          // Transition on the rest
          .filter(d => d.primary_mode !== d.primary_mode_driving)
            .transition()
            .duration(500)
              .style('opacity', 0.25)
            .transition()
            .duration(500)
            .delay((d, i) => i * 10)
              .style('opacity', 1)
              .style('fill', d => vm.modeColourScale(d.primary_mode))
 
        } else {
          
          // Set circles where they should be
          circles
            .style("opacity", 1)
            .attr("transform", "scale(1)")
            .attr("cx", d => vm.postcodeScale(d.postcode))
            .attr("cy", d => vm.ptYScale(d.avg_pt_time))
          // Transition the rest
          .transition()
            .duration(500)
            .delay((d, i) => i * 10)
              .attr("cx", d => d.BBoxCenter.x)
              .attr("cy", d => d.BBoxCenter.y)
            .transition()
              .duration(500)
              .style("opacity", 0)
            .transition()
              .attr("transform", "scale(0.000001)")

          // Transition paths
          paths
            .style('fill', d => vm.modeColourScale(d.primary_mode))
              .attr('transform', 'scale(1)')
          .transition()
            .duration(500)
            .delay((d, i) => 500 + i * 10)
              .style("opacity", 1)
        }

        // Hide all legends / axis
        selectAll('.legend, .axis')
          .style("opacity", 0)

        let legend = select(".map-legend")

        let legendOrdinal = legendColor()
          .shapeWidth(55)
          .orient('horizontal')
          .title('Primary PT travel mode to CBD')
          .cellFilter(function(d){ return d.label !== "unknown" && d.label !== "driving" })
          .scale(vm.modeColourScale);
          

        legend      
          .call(legendOrdinal)
        legend.select('.legendTitle')
          .attr("text-anchor", "middle")
        legend.select('.legendCells')
          .attr("transform", `translate(${-(3*55+2*2)/2},20)`)
        
        legend.transition()
          .delay(2000)
          .duration(500)           
          .style("opacity", 1);   
      },
      /*
       *  FOURTH VIEW
       *  How We Stack Up
       */
      draw_pt_scatter() {

        const vm = this
        let postcodes = selectAll('.postcode')
        let paths = postcodes.select('.postcode__path')
        let circles = postcodes.select('.postcode__circle')

        // Interrupt any existing transitions
        selectAll('*').interrupt()

        // Hide all legends / axis
        selectAll('.legend, .axis')
          .style("opacity", 0)

        // Bottom Axis
        let bottomAxis = select('.bottom-axis')
        bottomAxis
          .call(vm.postcodeAxis)
        bottomAxis
          .selectAll('.tick')
          .remove()
        bottomAxis
          .select('.axis-label')
          .text("Postcodes ranked by increasing CBD AM peak PT travel time")
        // Right Axis
        let rightAxis = select('.right-axis')
        rightAxis
          .call(vm.ptYAxis)
        rightAxis.select('.axis-label')
          .text("Sydney CBD AM peak PT travel time (Minutes)")
        // Transition timing
        let t = transition()
        
        if (vm.scrollDirection === 'DOWN') {
          // Set it where it should be
          paths
            .style('fill', d => vm.modeColourScale(d.primary_mode))
            .attr("transform", "scale(1)")
            .style("opacity", 1)
          // Transition the rest
          // Away with Shapes
          paths
            .transition()
            .duration(500)
            .delay((d, i) => i * 10)
              .style("opacity", 0)
            .transition()
              .attr('transform', 'scale(0.000001)')
              
          // Set circles where they should be
          circles
            .style("opacity", 0)
            .attr("transform", "scale(1)")
            .attr("cx", d => d.BBoxCenter.x)
            .attr("cy", d => d.BBoxCenter.y)
          // In with circles
          .transition()
            .duration(500)
            .delay((d, i) => i * 10)            
              .style("opacity", 1)
          .transition()
            .duration(500)
              .attr("cx", d => vm.postcodeScale(d.postcode))
              .attr("cy", d => vm.ptYScale(d.avg_pt_time))

          // Set transition timing for axis
          t.delay(1500).duration(1000)
              
        } else  {
          // Set where they should be
          circles
            .style("opacity", 1)
            .attr("transform", "scale(1)")
            .style("fill","rgb(108, 173, 213)")
            .attr("cx", d => vm.postcodeScale(d.postcode))
            .attr("cy", d => vm.rentYScale(d.avg_rent))
          // Transition to where the should go
          .transition()
            .duration(500)
              .attr("cx", d => vm.postcodeScale(d.postcode))
              .attr("cy", d => vm.ptYScale(d.avg_pt_time))

          t.delay(0).duration(100)
        } 
        
        selectAll('.bottom-axis, .right-axis, .ranking-arrow, .scatter-area')
          .transition(t)
            .style("opacity", 1)

      },
      /*
       *  FIFTH VIEW
       *  Time & Money
       */
      draw_rent_scatter() {

        const vm = this
        let postcodes = selectAll('.postcode')
        let paths = postcodes.select('.postcode__path')
        let circles = postcodes.select('.postcode__circle')
        
        // Interrupt any existing transitions
        selectAll('*').interrupt()

        if (vm.scrollDirection === 'DOWN') {
          
          // Set where circles should be
          circles
            .style("opacity", 1)
            .attr("transform", "scale(1)")
            .style("fill",d => vm.rentColourScale(d.avg_rent))
            .attr("cx", d => vm.postcodeScale(d.postcode))
            .attr("cy", d => vm.ptYScale(d.avg_pt_time))
          // Set where paths should be
          paths
            .attr('transform', 'scale(0.000001)')
            .style("opacity", 0)
          // Transition the rest  
          circles
            .transition()
            .duration(500)
            .delay((d, i) => i)
              .attr("cx", d => vm.postcodeScale(d.postcode))
              .attr("cy", d => vm.rentYScale(d.avg_rent))
                  
        } else {
          // Set it where it should be
          circles
            .style("opacity", 1)
            .attr("transform", "scale(1)")
            .attr("cx", d => vm.ptXScale(d.avg_pt_time))
            .attr("cy", d => vm.rentYScale(d.avg_rent))
          // Transition the rest
          .transition()
            .duration(1000)
            .style("fill",d => vm.rentColourScale(d.avg_rent))
            .attr("cx", d => vm.postcodeScale(d.postcode))
          
        }

        // Set where axis should be
        selectAll('.legend')
          .style("opacity", 0)
        
        selectAll('.axis')
          .style("opacity", 1)

        select('.bottom-axis')
            .call(vm.postcodeAxis)
            .selectAll('.tick')
              .style("opacity", 0)

        // Bottom axis
        select('.bottom-axis .axis-label')
          .text("Postcodes ranked by increasing CBD AM peak PT travel time")

        // Right Axis
        select('.right-axis .axis-label')
          .text("Average Weekly Rent ($, 2BDRM apartments)")
        
        select('.right-axis')
          .transition()
          .duration(500)
            .call(vm.rentAxis)
        
        select('.scatter-lines--first')
          .transition()
          .duration(500)
            .style("opacity", 1)
    
        select('.ranking-arrow')
        .transition()
          .duration(500)
            .style("opacity", 1)

      },
      /*
       *  DRAW SIXTH
       *  In the Zone
       */
      draw_rent_pt_scatter() {

        const vm = this
        let postcodes = selectAll('.postcode')
        let paths = postcodes.select('.postcode__path')
        let circles = postcodes.select('.postcode__circle')

        // interrupt any existing transitions

        selectAll('*').interrupt()

        // create transition after the interrupt !

        let t = transition()

        if (vm.scrollDirection === 'DOWN') {
          
          circles
          .style("opacity", 1)
          .attr("transform", "scale(1)")
          .attr("cx", d => vm.postcodeScale(d.postcode))
          .attr("cy", d => vm.rentYScale(d.avg_rent))
          .transition()   // transition the rest
          .duration(1000)
          .style("fill",d => vm.regionColourScale(d.region))
          .attr("cx", d => vm.ptXScale(d.avg_pt_time))

          // set the timing

          t.delay(0).duration(100)

        } else {

          // set circles

          circles
          .style("opacity", 0)
          .attr("cx", d => d.BBoxCenter.x)
          .attr("cy", d => d.BBoxCenter.y)
          .style("fill", d => vm.regionColourScale(d.region))
          .attr("transform", "scale(1)")
          .transition()     // fade in
          .duration(500)
          .delay((d, i) => i * 10)            
          .style("opacity", 1)
          .transition()     // transition to place
          .duration(500)
          .attr("cx", d => vm.ptXScale(d.avg_pt_time))
          .attr("cy", d => vm.rentYScale(d.avg_rent))

          // set paths

          paths
          .style("fill", d => vm.rentRealColourScale(d.avg_rent))
          .attr("transform", "scale(1)")
          .style("opacity", 1)
          .transition()     // fade away
          .duration(500)
          .delay((d, i) => i * 10)
          .style("opacity", 0)
          .transition()     // shrink
          .attr('transform', 'scale(0.000001)')

          // set the timing 

          t.delay(1500).duration(1000)

        }

        // hide legends and show axis
       
        // selectAll('.axis')
        // .style("opacity", 1)
        selectAll('.legend, .ranking-arrow')
        .style("opacity", 0)

        // bottom axis

        select('.bottom-axis')
        .call(vm.ptXAxis)
        select('.bottom-axis .axis-label')
        .text("Sydney CBD AM Peak pt travel time (Minutes)")
          
        // right Axis
        
        select('.right-axis')
        .call(vm.rentAxis)
        select('.right-axis .axis-label')
        .text("Average Weekly Rent ($, 2BDRM apartments)")
        
        // fade in the axis

        selectAll('.bottom-axis, .right-axis')
        .transition(t)
        .style("opacity", 1)
          
        // create legend

        var legendOrdinal = legendColor()
        .shapeWidth(55)
        .labelFormat(format(".0f"))
        .orient("horizontal")
        .cellFilter(function(d){ return d.label !== "Outer" })
        .scale(vm.regionColourScale)

        // draw legend
        
        select(".scatter-legend")
        .style("opacity", 0)
        .call(legendOrdinal)

        select(".scatter-legend .legendCells")
        .attr("transform", `translate(${-(6*55+10)/2},100)`)
          
        select(".scatter-legend")
        .transition(t)
        .style("opacity", 1)

        select('.scatter-lines--second')
        .transition(t)
        .style("opacity", 1)

      },
      /*
       *  DRAW SEVENTH
       *  Rent Stuff
       */
      draw_rent_map () {
        const vm = this
        let postcodes = selectAll('.postcode')
        let paths = postcodes.select('.postcode__path')
        let circles = postcodes.select('.postcode__circle')

        // interrupt any existing transitions
        selectAll('*').interrupt()

        // transition timing
        let t = transition()

        if (vm.scrollDirection === 'DOWN') {
          
          // set & transition circles
          
          circles
          .style("opacity", 1)
          .attr("transform", "scale(1)")
          .style("fill","rgb(108, 173, 213)")
          .style("fill",d => vm.regionColourScale(d.region))
          .attr("cx", d => vm.ptXScale(d.avg_pt_time))
          .attr("cy", d => vm.rentYScale(d.avg_rent))
          .transition()   // transition to position
          .duration(500)
          .delay((d, i) => i * 10)
          .attr("cx", d => d.BBoxCenter.x)
          .attr("cy", d => d.BBoxCenter.y)
          .transition()   // fade out
          .duration(500)
          .style("opacity", 0)
          .transition()   // shrink
          .attr("transform", "scale(0.000001)")

          // transform in paths

          paths
          .style('fill', d => vm.regionColourScale(d.region))
          .attr('transform', 'scale(1)')
          .transition()
          .duration(500)
          .delay((d, i) => 500 + i * 10)
          .style("opacity", 1)
          .transition()
          // .duration(500)
          .delay((d, i) => 1650 + i * - 10)   // to all transition at the same time
          .style('opacity', 0.25)
          .transition()
          .duration(500)
          .delay((d, i) => i * 10)
          .style('opacity', 1)
          .style('fill', d => vm.rentRealColourScale(d.avg_rent))

          // transition timing
          t.delay(5000).duration(500)

        } else {
          
          // set circles

          circles
          .style("opacity", 0)
          .attr("cx", d => d.BBoxCenter.x)
          .attr("cy", d => d.BBoxCenter.y)
          .attr("transform", "scale(0.000001)")

          // set paths
          console.log('FOO')

          paths
          .style("fill", d => vm.rentRealColourScale(d.avg_rent))
          .attr("transform", "scale(1)")
          .style("opacity", 1)

          // fade viz in

          select('.app__viz')
          .transition()
          .duration(300)
          .style("opacity", 1)

          // transition timing
          t.delay(0).duration(500)

        }

        // create legend

        var legendOrdinal = legendColor()
        .shapeWidth(55)
        .cells([300, 450, 600, 750, 900])
        .title("Average rent")
        .orient('horizontal')
        .labelFormat(format("($.0f"))
        .scale(vm.rentRealColourScale)

        // hide all legends / axis

        selectAll('.legend, .axis')
        .style("opacity", 0)

        // draw legend
        
        let legend = select(".map-legend")
        legend
        .call(legendOrdinal)
        legend.select('.legendTitle')
        .attr("text-anchor", "middle")
        legend.select('.legendCells')
        .attr("transform", `translate(-${(5*55+4*2)/2},20)`)
        legend.transition(t)
        .style("opacity", 1)
     
     },
      draw_findings () {
        const vm = this

        selectAll('*').interrupt()

        console.log('FADING')
        select('.app__viz')
          .transition()
          .duration(300)
          .style("opacity", 0)
      },
    }
  }
</script>

<style >
#greater-sydney {
  overflow: visible;
}

.postcode {
  stroke: #EAE4E4;
}
.findings h2 {
  font-size: 5.2rem;
  color:#3353ff;
}

.feather-x {
  width: 17px;
  height: 17px;
}

button {
  border: none;
  padding: 0;
  margin: 0;
  height: auto;
  line-height: 1;
}

.axis path,
.axis text,
.axis .tick
.axis .tick {
  font-family: "Heebo",Roboto, sans-serif;
  font-weight: 100;
  font-size: 12px;
  stroke: #555;
}

.axis .axis-label {
  font-family: "Heebo", Roboto, sans-serif;
  font-size: 21px;
  font-weight: 600;
  text-transform: uppercase;
  fill:#000;
  stroke: none;
}

.ranking-arrow path {
  stroke: none;
}
.cell .label{
  text-transform: capitalize;
}

.chartline-5,
.chartline-6,
.circle-6{
  stroke-width: 2px;
  stroke: #aaaaaa;
  stroke-dasharray:4
}
.circle-6{
  fill:none;
}
.area-4{
  fill:#F14F1D;
}

</style>